import { render, staticRenderFns } from "./confirm-boxset.vue?vue&type=template&id=6da6687f&"
import script from "./confirm-boxset.vue?vue&type=script&lang=js&"
export * from "./confirm-boxset.vue?vue&type=script&lang=js&"
import style0 from "./confirm-boxset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports